export default __webpack_public_path__ + "static/media/share_facebook.b8a1e352.png";